<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style"; 
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";

import Table from '@/components/company/branches/components/BranchTable'

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "Listado de Sedes",
    meta: [{ name: "description", content: appConfig.description }],
    
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
  },
  data() {
    return {
      title: "Listado de sedes",
       items: [
       
        {
          text: "Gestion empresa",
          href: "/forms/listado-empresa",
        },
        {
          text: "Listado de sedes",
          active: true,
        },
      ],
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goRegisterPage() {
      this.$router.push({
        name: "registro-sede",
        params: {
          id: this.$route.params.id,
        },
      });
    },
  },

};
</script>lk

<template>
  <Layout>
    <PageHeader :title="title"  :items="items"  />
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="form-group text-right m-b-0">
              <div class="col-12 text-right m-b-0">
                <div @click="goRegisterPage" class="btn btn-primary m-l-5 ml-1">
                  Agregar
                </div>

                <div @click="goBack" id="tooltip" class="btn btn-secondary m-l-5 ml-1">
                  <i class="fas fa-arrow-left"></i>
                </div>
                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
              </div>
            </div>

            <Table/>

          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>
